import React from 'react';
import { LockIcon } from 'lucide-react';
import { getUniversityBySlug } from '../../data/universityData';

// Shared Crestmont University brand chrome. The palette is fixed by the
// brand guide: deep navy as the primary surface, near-black ink for dark
// bands, and gold reserved for calls to action only.
export const CRESTMONT = {
  navy: '#00426b',
  ink: '#0b2338',
  gold: '#fcc23f',
  goldHover: '#e9ae26',
  mist: '#f1f3f5',
  paper: '#f7f9fb'
} as const;
interface CrestmontHeaderProps {
  /** Retained for callers; the nav has no in-nav CTA. */
  onApply?: () => void;
}

// The Crestmont nav bar: white surface with the official logo centered and a
// "Secure" mark on the right — matching the other partner pages so the lead
// experience stays consistent. The site footer is used below the content.
export function CrestmontHeader(_props: CrestmontHeaderProps) {
  const university = getUniversityBySlug('crestmont-university');
  return <header className="w-full bg-white border-b border-gray-100 py-5 px-4" data-id="element-250" data-mp="1fnihmbh9g508">
      <div className="max-w-7xl mx-auto flex items-center justify-center relative" data-id="element-251" data-mp="xbgc20tim4fr">
        <a href="/universities/crestmont-university" className="focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00426b] rounded" aria-label="Crestmont University home" data-id="element-252" data-mp="saiqrfd7kua1">
          {university?.logoUrl ? <img src={university.logoUrl} alt={university.name} decoding="async" className="h-12 md:h-14 object-contain" data-id="element-253" data-mp="1g14yf5jawcji" /> : <span className="text-xl font-bold" style={{
          color: CRESTMONT.navy
        }} data-id="element-254" data-mp="178kx1xbmjtuz">
              Crestmont University
            </span>}
        </a>
        <div className="hidden md:flex items-center gap-1.5 text-gray-400 text-xs font-medium absolute right-0" data-id="element-255" data-mp="1zovnq03of624">
          <LockIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-256" data-mp="1uxvtj2lxz23b" />
          Secure
        </div>
      </div>
    </header>;
}